const firebaseConfig = {
  apiKey: "AIzaSyAgw-5bCvOgl6O3TN4gkQVIqNBywCr6LNk",
  authDomain: "auth-rider-main.firebaseapp.com",
  projectId: "auth-rider-main",
  storageBucket: "auth-rider-main.appspot.com",
  messagingSenderId: "216708383832",
  appId: "1:216708383832:web:3c391aca339bac9267b62d"
};
  export default firebaseConfig;